/*
 * Copyright(C) 2018, xplo.re IT Services, Michael Maier.
 * All rights reserved.
 */

// Use of load for events is deprecated since 1.8 but still used by dzsparallaxer.
jQuery.fn.load = (function () {
    "use strict";

    var jLoad = jQuery.fn.load;

    return function (url) {
        var args = Array.prototype.slice.call(arguments);

        if (typeof url === "function") {
            // Old-style invocation, defer to event handler.
            args.unshift("load");
            return jQuery.fn.on.apply(jQuery, args);
        }

        return jLoad.apply(jQuery, args);
    };
}());